export default class Articles {
    constructor() {
        // Articles

        this.sharePost();
        this.copyLink();
    }

    sharePost() {
        const posts = document.querySelectorAll('.post');

        if (posts.length > 0) {
            posts.forEach((post) => {
                if (post.querySelector('.post__share') && post.querySelector('.post__popin')) {
                    post.querySelector('.post__share').addEventListener('click', (event) => {
                        event.preventDefault();
                        post.querySelector('.post__popin').classList.toggle('js-open');
                    });
                }
            });
        }
    }

    copyLink() {
        const btns = document.querySelectorAll('.post__popinCopy');

        if (btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (window.isSecureContext) {
                        /* global navigator */
                        navigator.clipboard.writeText(btn.dataset.url);
                        btn.classList.add('js-active');
                        setTimeout(() => {
                            btn.classList.remove('js-active');
                        }, 4000);
                    } else {
                        window.alert('La fonctionnalité est disponible unique en HTTPS'); // eslint-disable-line no-alert
                    }
                });
            });
        }
    }
}